import React from 'react';
import useReveal from '../common/hooks/useReveal';
import Contact from './Contact';
import Hero from './Hero';
import Overview from './Overview';
import Portfolios from './Portfolios';
import Service from './Service';
import Strengths from './Strengths';

/**
 * 원페이지 구성. 섹션 id 는 헤더 스크롤 스파이가 그대로 참조합니다.
 * hero → overview → strengths → service → portfolios → contact
 */
export default function Section() {
  useReveal();

  return (
    <main>
      <Hero />
      <Overview />
      <Strengths />
      <Service />
      <Portfolios />
      <Contact />
    </main>
  );
}
